"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_1 = require("react");
const semantic_ui_react_1 = require("semantic-ui-react");
const isPostalCode_1 = __importDefault(require("validator/es/lib/isPostalCode"));
const WalgreensCheckoutStepContainer_1 = __importDefault(require("./WalgreensCheckoutStepContainer"));
const useWalgreensCheckout_1 = __importDefault(require("./useWalgreensCheckout"));
const WalgreensStoreListItem_1 = __importDefault(require("./WalgreensStoreListItem"));
const react_redux_1 = require("react-redux");
const walgreensCheckoutReducer_1 = require("./walgreensCheckoutReducer");
const LoadingPage_1 = __importDefault(require("../../shared/LoadingPage"));
require("./WalgreensSelectStore.css");
const client_1 = require("@apollo/client");
const MapmakerApi_1 = require("../../../client/MapmakerApi");
(0, client_1.gql) `
  fragment WalgreensStore on WalgreensStore {
    storeNum
    promiseTime
    zip
    city
    state
    street
    phone
    distance
    distanceUnit
    openTime
    closeTime
    timeZone
    tax
  }

  query walgreensStores($input: WalgreensStoresInput!) {
    walgreensStores(input: $input) {
      ...WalgreensStore
    }
  }
`;
function WalgreensSelectStore() {
    const dispatch = (0, react_redux_1.useDispatch)();
    const [getStores, { loading, error, data }] = (0, MapmakerApi_1.useWalgreensStoresLazyQuery)();
    const [zip, setZip] = (0, react_1.useState)();
    const { productDetailsInput } = (0, useWalgreensCheckout_1.default)();
    const stores = data === null || data === void 0 ? void 0 : data.walgreensStores;
    function zipChange(e) {
        const zip = e.target.value;
        if ((0, isPostalCode_1.default)(zip, "US")) {
            setZip(zip);
            getStores({
                variables: {
                    input: {
                        zip,
                        productDetails: productDetailsInput,
                    },
                },
            });
        }
    }
    function selectStore(store) {
        dispatch((0, walgreensCheckoutReducer_1.setSelectedStore)(store, zip));
    }
    function renderStores() {
        return ((0, jsx_runtime_1.jsxs)(jsx_runtime_1.Fragment, { children: [(0, jsx_runtime_1.jsxs)(semantic_ui_react_1.Header, Object.assign({ sub: true }, { children: [stores.length, " ", stores.length == 1 ? "store" : "stores", " nearby stores"] })), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "store-list" }, { children: stores.map(store => {
                        return ((0, jsx_runtime_1.jsx)(WalgreensStoreListItem_1.default, { store: store, onSelect: selectStore }, store.storeNum));
                    }) }))] }));
    }
    function renderError() {
        return (0, jsx_runtime_1.jsx)("p", { children: error.message });
    }
    function renderWaitingOnInput() {
        return (0, jsx_runtime_1.jsx)("p", Object.assign({ className: "note" }, { children: "Enter your ZIP code to search for stores." }));
    }
    function renderResults() {
        if (error) {
            return renderError();
        }
        else if (loading) {
            return ((0, jsx_runtime_1.jsx)(LoadingPage_1.default, { style: { height: "300px" }, message: "Finding nearby stores" }));
        }
        else if (stores) {
            return renderStores();
        }
        else {
            return renderWaitingOnInput();
        }
    }
    return ((0, jsx_runtime_1.jsx)(WalgreensCheckoutStepContainer_1.default, Object.assign({ header: "Find a Walgreens near you" }, { children: (0, jsx_runtime_1.jsxs)("div", Object.assign({ id: "walgreens-select-store" }, { children: [(0, jsx_runtime_1.jsx)(semantic_ui_react_1.Input, { name: "zip", fluid: true, error: !!error, placeholder: "ZIP Code", defaultValue: "", icon: {
                        name: "search",
                        circular: true,
                        link: true,
                    }, onChange: zipChange }), (0, jsx_runtime_1.jsx)("div", Object.assign({ className: "result" }, { children: renderResults() }))] })) })));
}
exports.default = WalgreensSelectStore;
//# sourceMappingURL=data:application/json;base64,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